import {
	IconDownload,
	IconLightning,
	IconPersonChecked,
	IconPersons,
} from '@montel/montelpro-shared-components-v2';
import { TMenuItem } from 'components/common/Menu';

const menuConfig: TMenuItem[] = [
	{
		type: 'Clickable',
		text: 'Accounts',
		link: '/markets/users',
		icon: <IconPersons />,
	},
	{
		type: 'Clickable',
		text: 'Subscriptions',
		link: '/markets/subscriptions',
		icon: <IconPersonChecked />,
	},
	{
		type: 'Clickable',
		text: 'Provider Blacklist',
		link: '/markets/provider-blacklist',
		icon: <IconLightning />,
		truncateText: false,
	},
	{
		type: 'Clickable',
		text: 'Default Provider Blacklist',
		link: '/markets/default-provider-blacklist',
		icon: <IconLightning />,
		truncateText: false,
	},
	{
		type: 'Clickable',
		text: 'Provider Access Export',
		link: '/markets/provider-access-export',
		icon: <IconDownload />,
		truncateText: false,
	},
];

export default menuConfig;
